var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('page-header',{attrs:{"heading":"Activity Log","toggle":"offcanvas","target":"#offcanvasCreate"}}),_c('ActivityTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }